import store from '@/store/store';
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
/**
 * Route must be authenticate, if user is authenticated, push them to home
 */
export default function noAuth({ next, router, to}) {
  const token = store.getters.getLoggedInUserToken;
  if (token) {
    // if has shop location return to shop else to homepage
    if(to.params.store_slug){
      return router.push({ 
        name: 'StoreLanding', 
        params: { 
          business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug,
          store_slug:  to.params.store_slug
        },
        query: Helpers.refineQuery(['token','user_token'],to.query)
      });
    } else {
      return router.push({ 
        name: 'HomePage', 
        params: { 
          business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug 
        },
        query: Helpers.refineQuery(['token','user_token'], to.query)
      });
    }
    
  }
  return next();
}
